<div class="tablebox">
  <table class="table mb-0">
    <tr>
      <th>BC</th>
      <th>BAC/BAS</th>
      <th>Current Support (Q2)</th>
      <th>Current YTD GP%</th>
      <th>Running 12-month GP</th>
      <th>Support Based off Numbers</th>
      <th>GP Blocking</th>
      <th>Support Difference</th>
      <th>Notes:</th>
    </tr>
    <tr>
      <td>Regina Biggs</td>
      <td>Allison Pokorny/Barbara/Hazeltine/Bailey Doane</td>
      <td>200%</td>
      <td>$1,281,804.78</td>
      <td>$1,859,321.86</td>
      <td>230%</td>
      <td>$247,295.41</td>
      <td>-30%</td>
      <td>Allison 100% and Barbara 50% and Bailey Doane 50%</td>
    </tr>
    <tr>
      <td>Jeff Biggs</td>
      <td>Barbara/Hazeltine/Bailey Doane</td>
      <td>100%</td>
      <td>$631,986.89</td>
      <td>$788,098.05</td>
      <td>100%</td>
      <td>$78,724.81</td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>Betty Pinkston</td>
      <td>Desiree Spence</td>
      <td>10%</td>
      <td>$108,572.26</td>
      <td>$202,185.30</td>
      <td>30%</td>
      <td>$10,517.22</td>
      <td>-20%</td>
      <td></td>
    </tr>
    <tr>
      <td>Julie Reinhardt</td>
      <td>Desiree Spence</td>
      <td>15%</td>
      <td>$122,945.87</td>
      <td>$138,627.88</td>
      <td>20%</td>
      <td>$13,453.04</td>
      <td>-5%</td>
      <td></td>
    </tr>
    <tr>
      <td>Ashley Chavez</td>
      <td>Ashlee Tilford</td>
      <td>50%</td>
      <td>$255,386.73</td>
      <td>$256,559.18</td>
      <td>30%</td>
      <td>$50,698.85</td>
      <td>20%</td>
      <td></td>
    </tr>
  </table>
</div>
